<template lang="pug">
.pdp-gallery(v-if="product")
  .pdp-gallery__main
    swiper.pdp-gallery__main-swiper(
      :options="mainSwiperOptions" ref="mainSwiper"
      @slide-change="updateActiveThumb()"
    )
      swiper-slide.pdp-gallery__main-slide(v-for="(image, index) in productImages"
        :key="index"
        :data-slide-index="index"
        :data-is-variant-image="isVariantImage(image)"
        :data-color-variant-name="getVariantName(image)"
      )
        img.pdp-gallery__main-image(:src="image.sizes.lg" :alt="image.alt" :title="image.alt")
    .pdp-gallery__navigation(v-if="$mq !== 'mobile'")
      .pdp-gallery__navigation-arrow.pdp-gallery__navigation-arrow--next
        icon( name="chevron-left" size="18px")
      .pdp-gallery__navigation-arrow.pdp-gallery__navigation-arrow--prev
        icon(name="chevron-right" size="18px")
    //- product-badge(v-bind="{ product, variant }" v-if="enableBuyOnline")
  .pdp-gallery__thumbnail(v-if="productImages.length > 1")
    swiper.pdp-gallery__thumbnail-swiper(:options="thumbsSwiperOptions" ref="thumbSwiper")
      swiper-slide.pdp-gallery__thumbnail-slide(
        v-for="(image, index) in productImages"
        :key="index"
        :data-slide-index="index"
        v-show="showSelectedVariantImage(index, isVariantImage(image))")
        img.pdp-gallery__thumbnail-image(@click="slideToIndex(index, $event)" :src="image.sizes.xs" :alt="image.alt")
</template>

<script>
  import 'swiper/swiper.scss';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import Icon from 'scripts/components/basic/Icon.vue';
  import ProductBadge from 'scripts/components/product/ProductBadge.vue'

  export default {
    name: 'ProductGallery',
    components: {
      Icon,
      ProductBadge,
      swiper,
      swiperSlide
    },
    props: {
      product: Object,
      variant: Object,
      enableBuyInStore: Boolean,
      enableBuyOnline: Boolean,
    },
    data() {
      return {
        selectedVariantIndex: 0,
        mainSwiperOptions: {
          autoHeight: true, // Enabled to adjust height of slider to match image size
          loopedSlides: 1,
          threshold: 50,
          spaceBetween: 0,
          iOSEdgeSwipeDetection: true,
          iOSEdgeSwipeThreshold: 100,
          navigation: {
            nextEl: '.pdp-gallery__navigation-arrow--next',
            prevEl: '.pdp-gallery__navigation-arrow--prev'
          },
          breakpoints: {
            740: {}
          },
        },
        thumbsSwiperOptions: {
          loopedSlides: 1,
          centeredSlides: false,
          spaceBetween: 8,
          slidesPerView: 6,
          allowTouchMove: false,
          direction: 'horizontal',
          breakpoints: {
            1100: {
              spaceBetween: 10,
            }
          }
        }
      }
    },
    mounted() {},
    methods: {
      slideToIndex(slide_index, event) {
        this.$refs.mainSwiper.swiper.slideTo(slide_index, 500);
        this.updateActiveThumb(slide_index);
      },
      updateActiveThumb(slide_index) {
        const thumbSwiperEl = this.$refs.thumbSwiper.$el;
        const thumbSlides = thumbSwiperEl.querySelectorAll('.pdp-gallery__thumbnail-slide');
        const slideIndex = slide_index ? slide_index : this.$refs.mainSwiper.swiper.activeIndex;

        for (let i = 0; i < thumbSlides.length; i++) {
          i == slideIndex ? thumbSlides[i].classList.add('swiper-slide-active') : thumbSlides[i].classList.remove('swiper-slide-active');
        }
      },
      imageHasAlt(image) {
        return image.alt != null
          && image.alt != 'undefined'
          && this.allColorVariantNames != null
      },
      isVariantImage(image) {
        if(this.imageHasAlt(image)) {
          const alt_text = image.alt.split(" ")
          return alt_text.some((text) => this.allColorVariantNames.includes(this.replaceToDashAndLowercase(text)))
        }
      },
      getVariantName(image) {
        if(this.imageHasAlt(image)) {
          let image_alt = image.alt.split(" ")
          let alt_text = image_alt.map((alt) => alt.toLowerCase());
          return alt_text.filter((text) => this.allColorVariantNames.includes(this.replaceToDashAndLowercase(text)))
        }
      },
      showSelectedVariantImage(slideIndex, isVariantImage) {
        if (isVariantImage && slideIndex == this.selectedVariantIndex || !isVariantImage) {
          return true
        }
        return false;
      },
      replaceToDashAndLowercase(str) {
        return str.trim().replaceAll(/[^a-z0-9]/gmi, '-').toLowerCase()
      },
    },
    computed: {
      allColorVariantNames() {
        return this.product.options_color.map((option) => this.replaceToDashAndLowercase(option.substring(option.lastIndexOf("(") + 1, option.lastIndexOf(")")))) || null
      },
      productImages() {
        return this.product.images.default
      },
    }
  }
</script>

<style scoped lang="scss">
  .pdp-gallery {
    width: 100%;
    display: block;
    position: relative;
  }

  /* Main Swiper */

  .pdp-gallery__main {
    position: relative;
    width: 100%;

    @include tablet-up() {
      overflow: hidden;
    }
  }

  .pdp-gallery__main-swiper {}
  .pdp-gallery__main-slide {}

  /deep/ .pdp-gallery__main .swiper-slide {
    display: flex;
    justify-content: center;
    height: auto;
  }

  .pdp-gallery__main-image {
    width: 100%;
  }

  /* Thumbnail Swiper */

  .pdp-gallery__thumbnail {
    display: flex;
    align-items: center;
    height: calc(100% - 30px);
    top: 15px;
    left: 0;

    @include desktop-up() {
      height: calc(100% - 40px);
      top: 20px;
    }
  }

  .pdp-gallery__thumbnail-swiper {
    height: 100%;
    width: 100%;
    left: 0;
    padding: 0 0 24px 24px;

    @include tablet-up {
      padding: 0 0 24px
    }
  }

  .pdp-gallery__thumbnail-swiper .pdp-gallery__thumbnail-slide {
    cursor: pointer;
    margin: 0;
    overflow: hidden;
    box-sizing: border-box;
    background-color: $color-white;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 60px;

    @include full-width-up {
      height: 110px;
    }

    &:hover,
    &.swiper-slide-active {
      border-bottom: 3px solid var(--color-blue-500);
    }
  }

  .pdp-gallery__thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transform: scale(1.1);
  }

  // Navigtion
  .pdp-gallery__navigation {
    z-index: 5;
  }
  .pdp-gallery__navigation-arrow.pdp-gallery__navigation-arrow--prev,
  .pdp-gallery__navigation-arrow.pdp-gallery__navigation-arrow--next {
    position: absolute;
    width: 26px;
    height: 26px;
    top: calc(50% - 13px);
    right: 0;
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 1;
    background-color: var(--color-white);
    color: var(--color-navy-500);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .3s;

    &:hover,
    &:active {
      background-color: var(--color-navy-500);
      color: var(--color-white);
    }
    .icon {
      transform: rotate(180deg);
    }
    &.swiper-button-disabled {
      display: none;
    }
  }
  .pdp-gallery__navigation-arrow.pdp-gallery__navigation-arrow--prev {
    left: 0;
    right: auto;
  }
</style>
